import { useCallback } from "react";

import { useOriginWithWorkspace } from "src/router";
import {
  type LineageResourceLocation,
  lineageResourcePath,
} from "@hightouch/lib/lineage/graph/export/resource-path";

/** Absolute link to a lineage resource, or an empty string when it has no page. */
export function useLineageResourceUrl(): (
  node: LineageResourceLocation,
) => string {
  const originWithWorkspace = useOriginWithWorkspace();
  return useCallback(
    (node: LineageResourceLocation) => {
      const path = lineageResourcePath(node);
      return path ? `${originWithWorkspace}${path}` : "";
    },
    [originWithWorkspace],
  );
}
